import { library } from "@fortawesome/fontawesome-svg-core";
import { faCopy as farCopy } from "@fortawesome/free-regular-svg-icons";
import {
  faGraduationCap,
  faCheck,
  faChevronRight,
  faChevronLeft,
  faBell,
  faChevronUp,
  faChevronDown,
  faClock,
  faCircle,
  faSignOutAlt,
  faEdit,
  faPlusCircle,
  faTimesCircle,
  faEye,
  faTimes,
  faMinusCircle,
  faArrowLeft,
  faArrowRight,
  faInfoCircle,
  faSpinner,
  faAsterisk,
  faBook,
  faBookOpen,
  faHome,
  faPlus,
  faExclamationCircle,
  faFile,
  faPaperclip,
  faCheckCircle,
  faTrashAlt,
  faSyncAlt,
  faColumns,
  faMoneyCheck,
  faQuestion,
  faDollarSign,
  faEnvelope,
  faUsers,
  faTrash,
  faFileArrowUp,
  faTriangleExclamation,
  faMagnifyingGlass,
  faPaperPlane,
  faCalendarDays,
  faShare,
  faUserGraduate,
  faUserSlash,
  faEllipsisVertical,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faColumns,
  faGraduationCap,
  faCheck,
  faChevronRight,
  faChevronLeft,
  faBell,
  faChevronUp,
  faChevronDown,
  faClock,
  faCircle,
  faSignOutAlt,
  faEdit,
  faPlusCircle,
  faTimesCircle,
  faEye,
  faTimes,
  faMinusCircle,
  faArrowLeft,
  faArrowRight,
  faInfoCircle,
  faSpinner,
  faAsterisk,
  faBook,
  faBookOpen,
  faHome,
  faPlus,
  faExclamationCircle,
  faFile,
  faPaperclip,
  faCheckCircle,
  faEnvelope,
  faUsers,
  faTrashAlt,
  faSyncAlt,
  faMoneyCheck,
  faQuestion,
  faDollarSign,
  farCopy,
  faTrash,
  faFileArrowUp,
  faTriangleExclamation,
  faMagnifyingGlass,
  faPaperPlane,
  faCalendarDays,
  faShare,
  faUserGraduate,
  faUserSlash,
  faEllipsisVertical,
  faDownload,
);
